import { FC } from 'react';
import ExternalLink from '../../components/icons/ExternalLink.svg';
import styles from './SupportCard.module.css';
import { Support } from '../../pages/learn';

const SupportCard: FC<{ supportArticle: Support }> = ({ supportArticle }) => {
  return (
    <>
      <a href={supportArticle.url} target='_blank' rel='noreferrer'>
        <div className={styles['wrapper']}>
          <div className='flex justify-between mb-1'>
            <h3>{supportArticle.title}</h3>
            <ExternalLink className={styles['icon']} />
          </div>
          <p className='detail'>{supportArticle.description}</p>
        </div>
      </a>
    </>
  );
};

export default SupportCard;
